module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please wait, while map is loading")])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "525px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 18,
      "map-type-id": "terrain"
    }
  }, _vm._l((_vm.locations), function(gmp, index) {
    return _c('gmap-marker', {
      key: 'A' + index,
      attrs: {
        "clickable": true,
        "position": gmp,
        "icon": gmp.collectedStatus == true ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      },
      on: {
        "click": function($event) {
          _vm.showLocByIndex(index)
        },
        "closeclick": function($event) {
          _vm.showLocByIndex(null)
        }
      }
    }, [_c('gmap-info-window', {
      attrs: {
        "closeclick": true,
        "opened": _vm.showByIndex === index
      },
      on: {
        "closeclick": function($event) {
          _vm.showLocByIndex(null)
        }
      }
    }, [_c('div', {
      staticClass: "houseInfo"
    }, [(gmp.houseImage != 'null') ? _c('div', {
      staticClass: "houseImg"
    }, [_c('img', {
      attrs: {
        "src": gmp.houseImage
      }
    })]) : _vm._e(), _vm._v(" "), (gmp.hasOwnProperty('hnNo')) ? _c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "houses"
    }, [_vm._v(_vm._s(gmp.hnNo) + " (" + _vm._s(gmp.lineTowerName) + ")")])]) : _vm._e(), _vm._v(" "), (gmp.hasOwnProperty('houseNo')) ? _c('div', {
      staticClass: "mt-10"
    }, [_c('span', {
      staticClass: "houses"
    }, [_vm._v(_vm._s(gmp.houseNo) + " (" + _vm._s(gmp.name) + ")")])]) : _vm._e(), _vm._v(" "), (gmp.hasOwnProperty('memberCount')) ? _c('div', [_c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "550"
      }
    }, [_vm._v("Members: ")]), _c('span', [_vm._v(_vm._s(gmp.memberCount))])]) : _vm._e()])])], 1)
  }))], 1)])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e6c8e48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e6c8e48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/multiLocation.vue
// module id = 2301
// module chunks = 0